"use strict";

class SuperUnitTypesController {

    constructor(
        Upload,
        SSHttpService,
        SSUtilService,
        SSAlertService,
        SSAppService,
        SSConfigService,
        SSUserService,
        OTPService,
        SSDateService,
        SSConfirmationService
    ) {
        const self = this;

        self.Upload = Upload;
        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSAppService = SSAppService;
        self.SSConfigService = SSConfigService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSDateService = SSDateService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.unitTypes = null;
        self.dict_unitCategories = {};
        self.unitCategories = null;

        self.unitTypesTotalCount = null;
        self.unitTypesPagesCount = null;

        self.unitTypeParams = {
            pageNo: '1',
            offset: 0,
            limit: '20',
            send_total_count: true,
        };

        self.checked = 0;

        self.current = 1;
        self.jump_to_page = 1;

        self.selectedUnitType = null;
        self.unitTypeViewMode = null;
        self.unitTypeEditMode = null;

        self.getUnitCategories();
        self.getUnitTypes();

    }

    //-------------------------------------------


    getUnitCategories() {
        let self = this;

        let url = 'sec/super/unit-categories';
        let params = {
            limit: 50 // need to set limit as defaults to 15 if not set
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.unitCategories = response.data.unit_categories;

            self.unitCategories.forEach(element => {
                self.dict_unitCategories[element.id] = element.name;
            });
        });

    }

    getUnitTypes() {
        let self = this;

        let url = 'sec/super/unit-types';

        loading(true);
        self.SSHttpService.getAPIRequest(url, self.unitTypeParams).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.unitTypes = response.data.unit_types;
            self.unitTypesTotalCount = response.data.count;

            self.prepareUnitTypesPaginationData();
        });

    }

    prepareUnitTypesPaginationData() {
        const self = this;

        self.unitTypesPagesCount = Math.ceil(self.unitTypesTotalCount / self.unitTypeParams.limit);

        self.unitTypesPagesArray = [];
        for (let i = 0; i < self.unitTypesPagesCount; i++) {
            self.unitTypesPagesArray.push(i + 1);
        }

        if (self.unitTypesPagesCount < self.unitTypeParams.pageNo) {
            self.unitTypeParams.pageNo = 1;
        }
    }

    setPageNoAndLoadUnitTypes(pageNo) {
        const self = this;

        if (pageNo) {
            if (pageNo == 'next') {
                pageNo = self.unitTypeParams.pageNo + 1;
            } else if (pageNo == 'previous') {
                pageNo = self.unitTypeParams.pageNo - 1;
            }

            if (pageNo > self.unitTypesPagesCount) {
                pageNo = self.unitTypesPagesCount;
            } else if (pageNo < 1) {
                pageNo = 1;
            }

            if (pageNo == self.unitTypeParams.pageNo) {
                return; // Ignore if no change
            }

            self.unitTypeParams.pageNo = pageNo;
        }

        self.unitTypeParams.offset = (self.unitTypeParams.pageNo - 1) * self.unitTypeParams.limit;

        self.getUnitTypes();
    }

    setLimitAndLoadUnitTypes() {
        const self = this;

        self.unitTypeParams.pageNo = '1';
        self.unitTypeParams.offset = 0;
        self.unitTypeParams.send_total_count = 1;

        self.getUnitTypes();
    }

    setUnitTypeViewMode(mode, unitType) {
        const self = this;

        if (mode) {

            self.selectedUnitType = unitType;

            if (!self.selectedUnitType) {
                self.setUnitTypeEditMode(mode);
            }
        } else {
            self.selectedUnitType = null;
            self.setUnitTypeEditMode(mode);
        }

        self.unitTypeViewMode = mode;
    }

    setUnitTypeEditMode(mode) {
        const self = this;
        let temp = angular.copy(self.unitTypeParams);
        if (mode){
            if (self.selectedUnitType) {
                self.unitTypeParams = angular.copy(self.selectedUnitType);
            } else {
                self.unitTypeParams = {};
                self.unitTypeParams.pageNo = temp.pageNo;
                self.unitTypeParams.offset = temp.offset;
                self.unitTypeParams.limit = temp.limit;
                self.unitTypeParams.send_total_count = temp.send_total_count;
            }
        } else {

            self.unitTypeParams = {};
            self.unitTypeParams.pageNo = temp.pageNo;
            self.unitTypeParams.offset = temp.offset;
            self.unitTypeParams.limit = temp.limit;
            self.unitTypeParams.send_total_count = temp.send_total_count;

            if (!self.selectedUnitType) {
                self.unitTypeViewMode = mode;
            }
        }

        self.unitTypeEditMode = mode;
    }

    saveUnitType() {
        let self = this;

        self.OTPService.getVerified(self.OTPService.TYPE_SESSION_2FA, function (data) {

            self._saveUnitType();
        });
    }

    _saveUnitType() {
        let self = this;

        self.SSAlertService.clear();

        if (!self.unitTypeParams) {
            return;
        }

        let url = 'sec/super/unit-types/';
        let params = angular.copy(self.unitTypeParams);

        if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#unitTypeForm'))) {

            self.SSAlertService.danger("Please correct the following errors before you proceed.");

                self.propertyDiscountViewMode = true;
                self.setUnitTypeEditMode(true);
            return;
        }


        let responseHandler = function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            let existingUnitCategory= self.selectedUnitType;
            let newUnitCategory = response.data;

            if (existingUnitCategory && existingUnitCategory.id) {
                angular.merge(existingUnitCategory, newUnitCategory);
            } else {
                self.unitTypes.push(newUnitCategory);
            }

            self.setUnitTypeViewMode(false);
            self.setUnitTypeViewMode(true, newUnitCategory);
        };

        loading(true);
        if (self.unitTypeParams.id) {
            url +=  self.unitTypeParams.id;
            self.SSHttpService.putAPIRequest(url, params).then(responseHandler);
        } else {
            self.SSHttpService.postAPIRequest(url, params).then(responseHandler);
        }
    }

    deleteUnitCategory(unitTypeId) {
        let self = this;

        if (!unitTypeId)
            return;

        self.SSConfirmationService.getConfirmed(
            'Confirmation!',
            'Are you sure you want to delete this?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/super/unit-types/'+ unitTypeId + '/delete-unit-type';

                loading(true);
                self.SSHttpService.getAPIRequest(url).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        if(response.code == 409 && response.message){
                            self.SSAlertService.danger("Error!", response.message);
                        }
                        else{
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    // Remove from local data
                    jQuery.each(self.unitTypes, function (i, o) {
                        if (o.id == unitTypeId) {
                            self.unitTypes.splice(i, 1);
                            return false;
                        }
                    });
                });
            }
        );
    }

}

SuperUnitTypesController.$inject = [
    'Upload',
    'SSHttpService',
    'SSUtilService',
    'SSAlertService',
    'SSAppService',
    'SSConfigService',
    'SSUserService',
    'OTPService',
    'SSDateService',
    'SSConfirmationService'
];
app.controller('SuperUnitTypesController', SuperUnitTypesController);
